import React from 'react'

import { Row, Col } from '_zari/core'

import * as FormGroups from './formGroups'

const ParametrosSection = ({ isSubmitting, values }) => {
  return (
    <Row>
      <Col md={3} />
      <Col md={9}>
        <FormGroups.FlagValidarTokenEscritorioFormGroup
          fIsSubmitting={isSubmitting}
          iValue={values.flagValidarTokenEscritorio}
        />
        <FormGroups.FlagCambioAnoFormGroup fIsSubmitting={isSubmitting} iValue={values.flagCambioAno} />
        <FormGroups.FlagEditarVentasFormGroup fIsSubmitting={isSubmitting} iValue={values.flagEditarVentas} />
        <FormGroups.FlagAkdemicFormGroup fIsSubmitting={isSubmitting} iValue={values.flagAkdemic} />
        <FormGroups.FlagCambioCuenta12FormGroup fIsSubmitting={isSubmitting} iValue={values.flagCambioCuenta12} />
        <FormGroups.FlagCambioFechaFormGroup fIsSubmitting={isSubmitting} iValue={values.flagCambioFecha} />
        <FormGroups.FlagFacturacionConIGVFormGroup fIsSubmitting={isSubmitting} iValue={values.flagFacturacionConIGV} />
        <FormGroups.FlagVisible fIsSubmitting={isSubmitting} iValue={values.flagVisible} />
        <FormGroups.FlagVentaCobranzaAdministrativaFormGroup
          fIsSubmitting={isSubmitting}
          iValue={values.flagVentaCobranzaAdministrativa}
        />
        <FormGroups.FlagPuntoVentaFormGroup fIsSubmitting={isSubmitting} iValue={values.flagPuntoVenta} />
        <FormGroups.FlagTurnoFormGroup fIsSubmitting={isSubmitting} iValue={values.flagTurno} />
        <FormGroups.FlagModificarPrecioVentaFormGroup fIsSubmitting={isSubmitting} iValue={values.flagModificarPrecioVenta} />
        <FormGroups.FlagLogisticaFormGroup fIsSubmitting={isSubmitting} iValue={values.flagLogistica} />
        <FormGroups.FlagGerenciaFormGroup fIsSubmitting={isSubmitting} iValue={values.flagGerencia} />
        <FormGroups.TipoImpresionFormGroup fIsSubmitting={isSubmitting} iValue={values.tipoImpresion} />
      </Col>
    </Row>
  )
}

export default React.memo(ParametrosSection)
